module.exports = __webpack_public_path__ + "static/media/Reload.ab9343a2.svg";